<template>
  <div>
    <open-fund-header show-shopping-cart/>
    <div v-if="meitavAffiliates" class="r-text-intro">פתיחת קופה</div>
    <div v-else class="r-text-intro">תודה ששיתפת אותנו 💛</div>

    <div class="r-text-headline-paragraph">
      <div v-if="meitavAffiliates">
        <div>כל מה שצריך זה להביא</div>
        <div>
          <span class="r-text-bold"> תעודת זהות, ארנק וקפה.</span>

        </div>
      </div>
      <div v-else>
        <div>עכשיו כל מה שצריך</div>
        <div>
          <span>זה להביא </span>
          <span class="r-text-bold"> תעודת זהות,</span>
        </div>
        <div class="r-text-bold"> ארנק וקפה.</div>
      </div>
    </div>
    <div class="r-text-headline-paragraph">
      <div>עד השלוק האחרון, </div>
      <div>כבר יהיה לך חיסכון בקופת גמל להשקעה ב'מיטב'.</div>
    </div>
    <default-button label="אני רוצה להתחיל!" @click="next" />
  </div>
</template>

<script>
import TrackedPage from '@/mixins/TrackedPage';
import DefaultButton from '@/components/styled/DefaultButton';
import OpenFundHeader from '@/components/meitav-dash/OpenFundHeader';
import Affiliates from '@/mixins/Affiliates';
import { SIGNUP_FIRST_PAGE } from '@/router/consts';

export default {
  name: 'Coffee',
  components: { OpenFundHeader, DefaultButton },
  mixins: [TrackedPage, Affiliates],
  methods: {
    async next() {
      if (this.meitavAffiliates) {
        await this.$router.push(SIGNUP_FIRST_PAGE);
        return;
      }
      await this.$router.push('kgl');
    },
  },
};
</script>
